import { PricingTypeId } from "constants/pricingTypes";
import { roundNumber } from "lib/math";

interface CalculateTotalPriceCentsArgs {
  unitPrice: number | string | null | undefined;
  total_mass_grams: number | string | null | undefined;
  pricing_type_id: PricingTypeId;
  quantity: number;
}

export const calculateTotalPriceCents = ({
  unitPrice,
  total_mass_grams,
  pricing_type_id,
  quantity,
}: CalculateTotalPriceCentsArgs): number => {
  // Non-numeric unitPrice (undefined, null, empty string) is treated as
  // "no price entered" (0) rather than propagating NaN.
  const normalisedUnitPrice = Number(unitPrice) || 0;

  const unitPriceCents =
    pricing_type_id === PricingTypeId.PER_KILO
      ? normalisedUnitPrice
      : normalisedUnitPrice * 100;

  const normalisedQuantity =
    pricing_type_id === PricingTypeId.PER_HEAD ? quantity : 1;

  // When per kilo, and no mass is provided, it is assumed the pricing type is
  // actually gross.
  const totalMassGramsAsNumber = +total_mass_grams;
  if (
    pricing_type_id === PricingTypeId.PER_KILO &&
    Number.isInteger(totalMassGramsAsNumber) &&
    totalMassGramsAsNumber > 0
  ) {
    return roundNumber((unitPriceCents * totalMassGramsAsNumber) / 1000, 2);
  }
  return roundNumber(unitPriceCents * normalisedQuantity, 2);
};
